/** @jsxImportSource @emotion/react */

import React from 'react';
import { useVisible } from 'react-hooks-visible';
import { animated, useSpring } from 'react-spring';
import { AnimatedDelightProps } from './IAnimatedDelightProps';

export const AnimatedDelightRight = ({ endScale = 1, startScale = 0 }: AnimatedDelightProps) => {
  const [targetRef, isVisible] = useVisible((vi: number) => vi > 0.9);
  const style = useSpring({
    to: {
      transform: isVisible ? `scale3d(${endScale}, ${endScale}, ${endScale})` : `scale3d(${startScale}, ${startScale}, ${startScale})`
    },
    from: {
      transform: `scale3d(${startScale}, ${startScale}, ${startScale})`
    },
    delay: 300,
    config: {
      tension: 400,
      friction: 20
    }
  });

  const lineStyle = useSpring({
    to: {
      strokeDasharray: isVisible ? 560 : 560,
      strokeDashoffset: isVisible ? 0 : 560
    },
    from: {
      strokeDasharray: 560,
      strokeDashoffset: 560
    },
    delay: 400,
    config: {
      tension: 400,
      friction: 80
    }
  });

  return (
    <div
      css={{
        height: '100%',
        right: '0',
        position: 'absolute',
        top: '300px',
        zIndex: -1
      }}
    >
      <svg
        css={{
          display: 'none',

          [`@media (min-width: 1050px)`]: {
            display: 'block',
            height: '295px',
            position: 'sticky',
            right: '0',
            top: '300px',
            width: '222px',
          }
        }}
        ref={targetRef as any}
        viewBox="0 0 222 295"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <animated.path
          css={{
            transformOrigin: '200px 84px'
          }}
          style={style}
          d="M200.164 98.944c8.04 0 14.558-6.563 14.558-14.658 0-8.096-6.518-14.659-14.558-14.659s-14.557 6.563-14.557 14.659c0 8.095 6.517 14.658 14.557 14.658z"
          stroke="#D7E100"
          strokeWidth="10"
        />
        <animated.path
          css={{
            transformOrigin: '109px 13px'
          }}
          style={style}
          d="M109.181 25.652c7.034 0 12.737-5.742 12.737-12.826C121.918 5.742 116.215 0 109.181 0c-7.035 0-12.738 5.742-12.738 12.826 0 7.084 5.703 12.826 12.738 12.826z"
          fill="#6DAFB8"
        />
        <animated.path
          style={lineStyle}
          d="M194.779 285.129c-56.12 16.023-115.676-25.571-121.7-78.177-1.35-11.761.138-25.229 9.243-34.102 7.664-7.468 19.538-9.949 29.435-7.44 9.897 2.51 17.836 9.438 22.892 17.837 6.859 11.389 8.386 27.185-.379 38.623-8.044 10.511-22.373 14.601-35.416 15.29-37.25 1.973-72.662-19.453-85.771-51.881C-.027 152.85 9.984 111.39 37.31 84.874"
          stroke="#F46508"
          strokeWidth="10"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};
